<template>
  <button type="button" ref="toggle" class="a-nav-toggle" @click.prevent="toggle" :class="{ 'is-open': isOpen }">
    <span class="a-nav-toggle__label" v-if="!isOpen" v-text="$t('nav_label')"></span>
    <span class="a-nav-toggle__label" v-if="isOpen" v-text="$t('nav_label_close')"></span>
    <span class="a-nav-toggle__icon">
      <span class="a-nav-toggle__icon-bar"></span>
      <span class="a-nav-toggle__icon-bar"></span>
    </span>
  </button>
  <transition>
    <nav v-if="isOpen" ref="nav" class="m-nav-mobile">
      <slot />
    </nav>
  </transition>
</template>

<script>
import allyMaintainDisabled from 'ally.js/maintain/disabled'
import allyWhenKey from 'ally.js/when/key'

export default {
  data: () => ({
    isOpen: false,
    keyHandle: null,
    disabledHandle: null,
    scrollTop: null,
  }),

  methods: {
    open() {
      this.isOpen = true;
      this.$root.headroom.pin();
      this.$root.headroom.freeze();

      // https://github.com/medialize/ally.js/issues/139
      setTimeout(() => {
        this.disabledHandle = allyMaintainDisabled({
          filter: [this.$refs.nav, this.$refs.toggle, this.$root.$refs.header],
        });

        this.keyHandle = allyWhenKey({
          escape: () => {
            this.close();
          },
        });
      });
    },

    close() {
      this.isOpen = false;
      this.disabledHandle ? this.disabledHandle.disengage() : null;
      this.keyHandle ? this.keyHandle.disengage() : null;
      this.$root.headroom.unfreeze();
    },

    toggle() {
      this.isOpen ? this.close() : this.open();
    },
  },
}
</script>
